import React, { Suspense} from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { legacy_createStore as createStore, applyMiddleware } from 'redux'; //makes the Redux store available to the rest of your app
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import allReducers from './redux/reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { persistStore, persistReducer } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage';
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/index.scss";

const persistConfig = {
  key: 'root',
  storage,
}

const persistedReducer = persistReducer(persistConfig, allReducers);
const store = createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)));
const persistor = persistStore(store);
ReactDOM.render(
  <Suspense fallback={<span>Loading...</span>}>
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>
  </Suspense>, document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


